import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-visionbook-hero-redblazer.jpg`;
const ALT = "A closer view of Lara in a red coat, looking down at her open Vision Book.";

const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[#FF5A4F] text-white rounded-[8px] px-7 py-3.5 text-base font-medium hover:bg-[#e8463c] transition-colors";

export function FinalCTA() {
  return (
    <section data-testid="vbw-final-cta-section" className="relative overflow-hidden bg-white">
      <div className="relative w-full overflow-hidden reveal pb-[46px] lg:pb-0">
        {/* Reuse the Hero image with a closer, more intimate crop for
            visual continuity, per Page Lock. */}
        <div className="hidden lg:block absolute inset-y-0 right-0 w-[34%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="vbw-final-cta-image"
            bg="#FFFFFF"
            objectPosition="86% 40%"
            featherLeft={48}
            featherTop={10}
            featherBottom={10}
            className="absolute inset-0"
          />
        </div>

        <div className="lg:hidden relative w-full aspect-[4/3] mb-[30px]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="vbw-final-cta-image-mobile"
            bg="#FFFFFF"
            objectPosition="84% 30%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 lg:min-h-[520px] flex items-center">
          <div className="w-full lg:w-[62%]">
            <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
              Your Next Chapter
            </p>
            <h2 className="font-display text-[32px] sm:text-[42px] lg:text-[50px] leading-[1.15] tracking-tight text-[#1C1917] mb-6 max-w-lg">
              Your story is still being written.
            </h2>
            <div className="space-y-4 text-[20px] md:text-[22px] leading-relaxed text-[#57534E] max-w-lg mb-8">
              <p>You don&rsquo;t have to reinvent your life.</p>
              <p>You don&rsquo;t need a perfect plan.</p>
              <p>You don&rsquo;t have to know exactly where you&rsquo;re going.</p>
              <p>
                You simply need enough space to notice what your heart has
                been trying to tell you.
              </p>
              <p>Sometimes a single image changes everything.</p>
              <p>Sometimes it&rsquo;s a question.</p>
              <p>
                Sometimes it&rsquo;s the quiet realization that the life
                you&rsquo;ve been longing for has been gently calling your
                name all along.
              </p>
              <p className="text-[#1C1917]">
                Let&rsquo;s create a Vision Book you&rsquo;ll still be opening
                years from now.
              </p>
            </div>
            <a
              href="#workshop-options"
              data-testid="vbw-final-cta-button"
              className={btnPrimary}
            >
              Notify Me
            </a>
            <p className="mt-6 text-lg text-[#8A8580] italic max-w-md">
              Your future doesn&rsquo;t need to shout.
            </p>
            <p className="text-lg text-[#8A8580] italic max-w-md">
              It only needs a moment where you&rsquo;re finally ready to
              listen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
